<template>
  <div class="goods-card-wrap" @click="toDetail">
    <!-- <MediaWrap :url="instance.picture" :width="180" :height="180"></MediaWrap> -->
    <div class="content-wrap">
      <a-row class="title-row">
        <a-col class="title-item-wrap" :span="16">
          <span class="title single-omit">{{ instance.name }}</span>
        </a-col>
        <a-col :span="4"
          ><div class="block" v-if="instance.tag && instance.tag !== null">
            {{ instance.tag }}
          </div></a-col
        >
        <a-col class="collection-wrap" :span="4">
          <span class="iconItem">
            <a-icon type="eye" :style="{ color: '#364759' }" />
            <span>{{ instance.browseNum }}</span>
          </span>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="12">
          <div class="list-item">
            <span>{{ instance.user.enpName || '-' }} </span>
          </div>
        </a-col>
        <a-col :span="12">
          <div class="list-item">
            <span>需求类型：{{ instance.demandsTypeStr || '-' }}</span>
          </div>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="12">
          <div class="list-item">
            <span>技术分类：{{ instance.technicalTypeStr || '-' }}</span>
          </div>
        </a-col>
        <a-col :span="12">
          <div class="list-item">
            <span>产业分类：{{ instance.industrialTypeStr || '-' }}</span>
          </div>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="12">
          <span>发布时间：</span>
          <span>{{ instance.publishTime || '-' }}</span>
        </a-col>
      </a-row>
      <a-row>
        <a-col class="price-wrap" :span="8" :offset="16">
          <span class="price"
            >价格：
            {{
              instance.priceRange === -1 ? ' 面议' : `￥${instance.priceRange}`
            }}</span
          >
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
import { isView } from '@/api/technicalR'
export default {
  props: {
    instance: Object
  },
  data() {
    return {
      collectStatus: 'outlined',
      collectColor: { color: '#364759' },
      operationTypeColor: {
        0: '#89C997', // 转让
        1: '#6582FF', // 许可
        2: '#2279D2' // 质押
      }
    }
  },
  created() {
    this.handleCollectStatus()
  },
  methods: {
    async toDetail() {
      const { id } = this.instance

      this.$router.push({ name: 'techDetailDeal', query: { id } })
      await isView(id)
    },
    handleCollect(e, id) {
      const {
        instance: { is_collect }
      } = this
      e.stopPropagation()
      this.$emit('collectStatus', id, is_collect)
    },
    // 收藏样式变化
    handleCollectStatus() {
      const {
        instance: { is_collect }
      } = this
      if (is_collect) {
        this.collectStatus = 'filled'
        this.collectColor = { color: '#57b9fe' }
        return
      }
    }
  }
}
</script>
